
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Color, GlobalColor } from "@/types/colors";
import { globalStore } from "@/store/store";
import { createVariableName } from "@/lib/colors/colors";

import VueColorWrapper from "@/components/Reusable/CustomInputs/3rdPartyWrappers/VueColorWrapper.vue";
import Icon from "@/components/UI/Icon.vue";
import Dialog from "@/components/UI/Dialog.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { saveGlobalSettingsToWordPress } from "@/lib/global-settings/global-settings";
import { isUiPanelOpen } from "@/lib/panels/panels";

@Component({
  components: { Icon, VueColorWrapper, Dialog, TextInput }
})
export default class SaveColorDialog extends Vue {
  @Prop()
  value!: Color;

  openDialog: boolean | null = null;

  label: string | null = null;

  saveAsGlobal() {
    if (!this.label) return;

    const color: GlobalColor = {
      cssVariableName: createVariableName(this.label, this.cssVarSuffix),
      label: this.label,
      value: this.unwrappedColor
    };

    if (this.value.type === "solid") {
      globalStore.addGlobalColor(color);
    } else {
      globalStore.addGlobalGradient(color);
    }

    // Unless global settings panel is already open, persist this on the server
    if (!isUiPanelOpen("globalSettings")) {
      saveGlobalSettingsToWordPress();
    }

    this.$emit("input", color);
    this.openDialog = false;
  }

  get cssVarSuffix() {
    const prefix = this.value.type === "solid" ? "" : "gradient-";
    const index = globalStore.globalColors.length + 1; //
    return prefix + index;
  }

  get unwrappedColor() {
    if (this.value.type === "solid") {
      return this.value.value;
    }

    return this.value;
  }

  closeDialog() {
    this.label = "";
    this.openDialog = false;
  }
}
